<template>
    <div class="rich-text-container">
      <quill-editor
        v-model="localContent"
        :options="editorOptions"
        :disabled="uploading"
        @change="onEditorChange"
      >
        <div id="custom-toolbar" slot="toolbar">
          <!-- Text Style Controls -->
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
          </span>
  
          <!-- Text Alignment -->
          <span class="ql-formats">
            <select class="ql-align">
              <option selected></option>
              <option value="center"></option>
              <option value="right"></option>
              <option value="justify"></option>
            </select>
          </span>
  
          <!-- Lists -->
          <span class="ql-formats">
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
          </span>
  
          <!-- Indentation -->
          <span class="ql-formats">
            <button class="ql-indent" value="-1"></button>
            <button class="ql-indent" value="+1"></button>
          </span>
  
          <!-- Links and Media -->
          <span class="ql-formats">
            <button class="ql-link"></button>
            <button class="ql-image"></button>
          </span>
        </div>
      </quill-editor>
    </div>
  </template>
  
  <script>
  import { quillEditor } from 'vue-quill-editor'
  import 'quill/dist/quill.snow.css'
  
  export default {
    name: 'EnhancedTextEditor',
    
    components: {
      quillEditor
    },
  
    props: {
      value: {
        type: String,
        default: ''
      },
      uploading: {
        type: Boolean,
        default: false
      },
      type: {
        type: Number,
        required: true
      }
    },
  
    data() {
      return {
        localContent: this.value,
        editorOptions: {
          modules: {
            toolbar: '#custom-toolbar'
          },
          theme: 'snow',
          placeholder: 'Enter your content here...',
          readOnly: this.uploading
        }
      }
    },
  
    watch: {
      value(newVal) {
        if (newVal !== this.localContent) {
          this.localContent = newVal
        }
      },
      
      uploading(newVal) {
        this.editorOptions.readOnly = newVal
      }
    },
  
    computed: {
      showEditor() {
        return this.type === 4 || this.type === 3
      }
    },
  
    methods: {
      onEditorChange({ html, text }) {
        this.$emit('input', html)
        this.$emit('change', {
          html,
          text
        })
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .rich-text-container {
    margin-bottom: 20px;
    
    .ql-editor {
      min-height: 150px;
      max-height: 400px;
      overflow-y: auto;
    }
  
    // Match Vuetify's disabled state
    .ql-disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
  
      .ql-editor {
        cursor: not-allowed;
      }
    }
  
    // Custom scrollbar
    .ql-editor::-webkit-scrollbar {
      width: 8px;
    }
  
    .ql-editor::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
  
    .ql-editor::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }
  
    .ql-editor::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  </style>